import React from 'react';
import { Form, Input, Select } from 'antd';

export default function OrderCustomerFields(props) {
    const provinces = Array.isArray(props.provinces) ? props.provinces : [];
    const wards = Array.isArray(props.wards) ? props.wards : [];
    return (
        <section className="order-form-card order-form-customer-card">
            <div className="order-form-card__header">
                <div className="order-form-card__icon"><i className="fas fa-user" /></div>
                <div>
                    <div className="order-form-card__title">Thông tin khách hàng</div>
                </div>
            </div>

            <div className="order-form-grid order-form-grid--two-columns">
                <Form.Item
                    className="order-form-item"
                    label="Họ tên"
                    name="full_name"
                    rules={[{ required: true, message: 'Tên khách hàng không được để trống' }]}
                >
                    <Input placeholder="Nhập họ và tên khách hàng" />
                </Form.Item>

                <Form.Item className="order-form-item" label="Số điện thoại" name="phone" rules={[{ required: true, message: 'Số điện thoại không được để trống' }]}>
                    <Input placeholder="0xxx xxx xxx" />
                </Form.Item>
            </div>

            <Form.Item className="order-form-item" label="Địa chỉ chi tiết" name="address" rules={[{ required: true, message: 'Địa chỉ chi tiết không được để trống' }]}>
                <Input placeholder="Số nhà, tên đường..." />
            </Form.Item>

            <div className="order-form-grid order-form-grid--two-columns order-address-grid">
                <Form.Item
                    className="order-form-item"
                    label="Tỉnh / Thành phố"
                    name="province_id"
                    rules={[{ required: true, message: 'Chọn Tỉnh / Thành phố' }]}
                >
                    <Select
                        showSearch
                        loading={!!props.loadingProvinces}
                        placeholder="Chọn Tỉnh / Thành phố"
                        optionFilterProp="children"
                        onChange={props.onProvinceChange}
                    >
                        {provinces.map((item) => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
                    </Select>
                </Form.Item>

                <Form.Item
                    className="order-form-item"
                    label="Phường / Xã / Đặc khu"
                    name="ward_id"
                    rules={[{ required: true, message: 'Chọn Phường / Xã / Đặc khu' }]}
                >
                    <Select
                        showSearch
                        disabled={!props.selectedProvinceId}
                        loading={!!props.loadingWards}
                        placeholder={props.selectedProvinceId ? 'Chọn Phường / Xã / Đặc khu' : 'Chọn Tỉnh / Thành phố trước'}
                        optionFilterProp="children"
                    >
                        {wards.map((item) => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
                    </Select>
                </Form.Item>
            </div>
        </section>
    );
}
